export * from "./proptypes";
export * from "./colors";



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/dist/helpers/index.js
// module id = 20
// module chunks = 0